import { memo } from 'react';
import { useTranslation } from 'next-i18next';

/** 賠率走勢提示 */
const OddsChanges = () => {
    const { t } = useTranslation('kol');
    const data = [
        { color: `bg-[#FF0000]`, text: `${t('odds.favourite')}` },
        { color: `bg-[#6EBC3F]`, text: `${t('odds.oddsDrop20')}` },
        { color: `bg-[#B64D18]`, text: `${t('odds.oddsDrop50')}` },
    ];
    return (
        <div>
            <div className='text-black text-[11px] font-bold pb-2'>{t('odds.oddsChanges')}</div>
            <div className='flex flex-wrap justify-between gap-2'>
                {data.map((i, index) => (
                    <div className='flex' key={index}>
                        <div
                            className={`w-[30px] h-[15px] leading-[15px] rounded-sm ${i.color} text-center text-[11px] font-bold text-white`}
                        >
                            00
                        </div>
                        <div className='pl-1 text-black font-normal text-[11px]'>{i.text}</div>
                    </div>
                ))}
            </div>
            <div className='py-3 text-[11px] text-black font-normal'>{t('odds.winOdssTips')}</div>
        </div>
    );
};

export default memo(OddsChanges);
